import { Phone, Mail, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { PaymentBadges, WhatsAppIcon } from "./Icons";
import { useLang } from "../i18n/LanguageContext";
import { WHATSAPP_URL, PHONE_DISPLAY, PHONE_TEL, EMAIL } from "../lib/config";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-black/5 bg-[var(--paper)] pb-40 pt-16 lg:pb-12" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[var(--mist)]">{t.footer.tagline}</p>
            <p className="mt-4 flex items-center gap-2 text-sm text-slate-500"><Clock className="h-4 w-4 text-[var(--coral)]" />{t.footer.hours}</p>
          </div>
          <div>
            <p className="eyebrow">{t.footer.contact}</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="group flex items-center gap-3 font-medium text-[var(--ink)]" data-testid="footer-whatsapp"><span className="flex h-9 w-9 items-center justify-center rounded-full bg-[var(--wa)]/15 text-[#128C7E] transition group-hover:bg-[var(--wa)]/30"><WhatsAppIcon className="h-4 w-4" /></span>{t.footer.whatsapp}</a></li>
              <li><a href={`tel:${PHONE_TEL}`} className="group flex items-center gap-3 font-medium text-[var(--ink)]" data-testid="footer-phone"><span className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition group-hover:bg-slate-200"><Phone className="h-4 w-4" /></span>{PHONE_DISPLAY}</a></li>
              <li><a href={`mailto:${EMAIL}`} className="group flex items-center gap-3 font-medium text-[var(--ink)]" data-testid="footer-email"><span className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition group-hover:bg-slate-200"><Mail className="h-4 w-4" /></span>{EMAIL}</a></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow">{t.footer.payments}</p>
            <div className="mt-5"><PaymentBadges /></div>
            <p className="mt-5 text-xs leading-relaxed text-slate-400">{t.footer.legal}</p>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-black/5 pt-6 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Tenerife Excursions. {t.footer.rights}</p>
          <p data-testid="footer-credit">{t.footer.built} <a href="https://www.onlineofficesolutions.co.uk" target="_blank" rel="noreferrer" className="font-semibold text-[var(--ink)] underline-offset-4 transition hover:text-[var(--coral)] hover:underline">Online Office Solutions</a></p>
        </div>
      </div>
    </footer>
  );
};
